import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import { FiX } from "react-icons/fi";
import Skeleton from "react-loading-skeleton";
import DynamicInput from "../../../components/DynamicInput";
import { DocsSide } from "../../../components/DocsSide";
import { IDocument } from "../../../types/DocumentTypes";
import api from "../../../services/api";

import {
	Container,
	Content,
	DivergencesTable,
	TableLine,
	NewResponse,
} from "./styles";

import { questionsByName } from "../../../misc/customOptions";
import { findCity, findState, findUF } from "../../../misc/optionsUtils";
// import { get_city, get_country, get_state, get_uf } from "../../../misc/customOptions";

interface ITypistsErrors {
	type: string;
	typist_one: string;
	typist_two: string;
}

interface ITypeProcess {
	id: number;
	infos: Object;
	infos_two: Object;
	documents: IDocument[];
}

interface FormattedDivergence {
	type: string;
	typist_one: { value: string; label: string } | string;
	typist_two: { value: string; label: string } | string;
}

const ProcessError = () => {
	const [correctList, setCorrectList] = useState({});
	const [divergences, setDivergences] = useState<FormattedDivergence[]>([]);
	const [process, setProcess] = useState<ITypeProcess>();
	const { id } = useParams<any>();

	const history = useHistory();
	const backButton = () => {
		history.push("gerenciamento-de-processos");
	};

	const get_divergences = async (id: any) => {
		let divergences: any = {};
		try {
			const { data: dataProcess } = await api.get(
				`/data/process&id=${id}`,
			);
			setProcess(dataProcess.data);
			const { data: divergencesData } = await api.get(
				`/data/process&id=${id}/divergences`,
			);

			divergences = divergencesData.data;
			console.log("divergences data", divergencesData.data);
			// divergencesData.data.forEach((divergence: any) => {
			// 	console.log(divergence);
			// })
		} catch (error) {
			return error;
		}

		let formattedDivergencesArray: FormattedDivergence[] = Object.entries<{
			type: string;
			typist_one: string;
			typist_two: string;
		}>(divergences)
			.map(([key, divergence], index) => {
				let formattedDivergence: FormattedDivergence = {
					type: key,
					typist_one: "",
					typist_two: "",
				};
				const divergenceQuestion = questionsByName[key];
				// if (!divergenceQuestion){
				// 	return;
				//

				if (divergenceQuestion.optionsType) {
					// console.log('TESTE 1', divergence,  divergenceQuestion)
					switch (divergenceQuestion.optionsType) {
						case "state":
							const stateOne = findState(divergence.typist_one);
							const stateTwo = findState(divergence.typist_two);

							formattedDivergence.typist_one = stateOne
								? stateOne.label
								: "";
							formattedDivergence.typist_two = stateTwo
								? stateTwo.label
								: "";

							break;

						case "uf":
							const ufOne = findUF(divergence.typist_one);
							const ufTwo = findUF(divergence.typist_two);

							formattedDivergence.typist_one = ufOne
								? ufOne.label
								: "";
							formattedDivergence.typist_two = ufTwo
								? ufTwo.label
								: "";
							break;

						case "city":
							const cityOne = findCity(divergence.typist_one);
							const cityTwo = findCity(divergence.typist_two);

							formattedDivergence.typist_one = cityOne
								? cityOne.label
								: "";
							formattedDivergence.typist_two = cityTwo
								? cityTwo.label
								: "";
							break;
					}
				} else {
					if (divergenceQuestion.type === "select") {
						const optionOne = divergenceQuestion.options.find(
							(option: any) =>
								option.value === divergence.typist_one,
						);
						const optionTwo = divergenceQuestion.options.find(
							(option: any) =>
								option.value === divergence.typist_two,
						);

						formattedDivergence.typist_one = optionOne
							? optionOne.label
							: "";
						formattedDivergence.typist_two = optionTwo
							? optionTwo.label
							: "";

						return formattedDivergence;
					}
					let {
						typist_one: divergenceTypistOneValue,
						typist_two: divergenceTypistTwoValue,
					} = divergence;
					formattedDivergence.typist_one = divergenceTypistOneValue
						? divergenceTypistOneValue
						: "";
					formattedDivergence.typist_two = divergenceTypistTwoValue
						? divergenceTypistTwoValue
						: "";
				}

				return formattedDivergence;
			})
			.filter((item: any) => item !== undefined || item !== null);
		// console.log('OI')

		setDivergences(() => formattedDivergencesArray);
	};

	useEffect(() => {
		get_divergences(id);
	}, []);

	const Divergence = ({ type, typist_one, typist_two }: ITypistsErrors) => {
		const [selected, setSelected] = useState<number | null>(null);
		const [correctAnswer, setCorrectAnswer] = useState("");
		const question = questionsByName[type];

		useEffect(() => {
			let newObj = correctList;
			if (selected !== null)
				// @ts-ignore
				newObj[type] =
					selected === 1
						? typist_one
						: selected === 2
						? typist_two
						: correctAnswer;

			setCorrectList(newObj);
		}, [correctAnswer, selected]);

		return (
			<TableLine>
				<td className='text-cell question' title={question.title}>
					{question.title}
				</td>
				<td className='text-cell' title={typist_one}>
					{typist_one}
				</td>
				<td className='text-cell' title={typist_two}>
					{typist_two}
				</td>
				<td>
					{selected === 0 ? (
						<NewResponse className='new-response'>
							<DynamicInput
								type={question.type}
								options={question.options || null}
								placeholder={question.title}
								name={question.name}
								mask={question.mask}
								title={""}
								onChange={(e: any) =>
									setCorrectAnswer(e.target.value)
								}
								handleSelectChange={(
									name: string,
									value: any,
								) => setCorrectAnswer(value)}
							/>

							<button onClick={() => setSelected(null)}>
								<FiX size={20} />
							</button>
						</NewResponse>
					) : (
						<div className='options'>
							<button
								className={`circle-button ${
									selected === 1 ? "active" : ""
								}`}
								onClick={() => {
									setSelected(1);
								}}>
								1
							</button>
							<button
								className={`circle-button ${
									selected === 2 ? "active" : ""
								}`}
								onClick={() => {
									setSelected(2);
								}}>
								2
							</button>
							<button
								className={`rectangle-button ${
									selected === 0 ? "active" : ""
								}`}
								onClick={() => {
									setSelected(0);
								}}>
								NENHUM
							</button>
						</div>
					)}
				</td>
			</TableLine>
		);
	};

	const handleSend = async () => {
		const correct_infos = { ...process!.infos, ...correctList };
		try {
			if (process)
				await api.patch(`/data/process&id=${id}/divergences`, {
					correct_infos,
				});
			backButton();
		} catch (error) {
			return error;
		}
	};

	return (
		<Container>
			<Content>
				<div className='header'>
					Analista
					<h1>Divergência entre digitadores</h1>
				</div>

				{!divergences.length ? (
					<Skeleton
						count={10}
						width='90%'
						height={40}
						style={{ marginTop: 20 }}
					/>
				) : (
					<>
						<DivergencesTable cellSpacing={0}>
							<thead>
								<TableLine>
									<th>
										<p>PERGUNTA</p>
									</th>
									<th>
										<p>DIGITADOR 1</p>
									</th>
									<th>
										<p>DIGITADOR 2</p>
									</th>
								</TableLine>
							</thead>
							<tbody>
								{divergences
									? divergences.map((divergence, index) => (
											<Divergence
												key={index}
												type={divergence.type}
												typist_one={
													typeof divergence.typist_one ===
													"object"
														? divergence.typist_one
																.label
														: divergence.typist_one
												}
												typist_two={
													typeof divergence.typist_two ===
													"object"
														? divergence.typist_two
																.label
														: divergence.typist_two
												}
											/>
									  ))
									: null}
							</tbody>
						</DivergencesTable>

						<div className='buttons'>
							<button
								onClick={backButton}
								className='go-back-button'>
								Voltar
							</button>
							<button
								className='send-button'
								onClick={handleSend}>
								Enviar
							</button>
						</div>
					</>
				)}
			</Content>

			{/* <DisplayDocuments src='http://www.africau.edu/images/default/sample.pdf' /> */}
			{process?.documents ? <DocsSide docs={process?.documents} /> : ""}
		</Container>
	);
};

export default ProcessError;
